import React, { Component } from "react";
import { watchPollStatus } from "../action/device_status.action";
import { sagaMiddleware } from "../helper/store"
import { connect } from "react-redux";
import { Row, Col, Icon, Spin, message, Button, Divider } from 'antd';
import UserControls from "../component/scanner/user_controls"
import { ProgressStateConstant } from "../actionTypes/progress_state.constant"
import ScanWorkflow from "../component/scanner/scan_workflow"
import ScanProgress from "../component/scanner/scan_progress"
import { Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom'
import axios from 'axios';
import { AuthHeader } from "../helper/auth.token"
import { globalUrlPrefix } from "../utils/const"

class ScannerView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allow_workflow_access: false,
            starting_scanner: false, 
            scannerServerBusy: false, 
            scannerServerBusyMessage: "Booting Scanner"
        }
        this.usbConnectionCodeDict = {
            DISCONNECTED : "DISCONNECTED",
            CONNECTED : "CONNECTED",
            INITIALISED : "INITIALISED", 
            ERRORED : "ERRORED", 
        }
        this.hardwareDict = {
            CAMERA : "Camera", 
            SERIAL : "Serial", 
            PREVIEW_CAMERA : "Preview Camera"
        }
        this.powerStatusDict = {
            UNKNOWN : "UNKNOWN",
            DISCONNECTED : "DISCONNECTED",
            CONNECTED : "CONNECTED"
        }
    }

    startScanner = () => {
        let id = this.props.match.params.id;
        this.setStartingScanner();
        let url = `/devices/` + id + '/start_scanner/';
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status === 200) {
                    this.setDoneStartingScanner();
                }
                else {
                    this.setDoneStartingScanner();
                    message.error("Failed to Start Scanner. Contact Admin");
                }
            })
            .catch(err => {
                this.setDoneStartingScanner();
                console.log(err);
            })

    }

    startScannerServer = () => {
        let id = this.props.match.params.id;
        this.setScannerServerBusy("Booting Scanner");
        let url = `/devices/` + id + '/start_scanner_server/';
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status !== 200) {
                    message.error("Failed to Start Scanner. Contact Admin!");
                    this.setScannerServerIdle();
                }
            })
            .catch(err => {
                this.setScannerServerIdle();
                console.log(err);
            })

    }

    stopScannerServer = () => {
        let id = this.props.match.params.id;
        this.setScannerServerBusy("Shutting Down Scanner");
        let url = `/devices/` + id + '/stop_scanner_server/';
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status !== 200) {
                    message.error("Failed to Stop Scanner. Contact Admin!");
                }
                this.setScannerServerIdle();
            })
            .catch(err => {
                this.setScannerServerIdle();
                console.log(err);
            })

    }

    setStartingScanner = () => this.setState(Object.assign({}, this.state, { starting_scanner: true }));

    setDoneStartingScanner = () => this.setState(Object.assign({}, this.state, { starting_scanner: false }));

    setScannerServerBusy = (message) => this.setState(Object.assign({}, this.state, { scannerServerBusy: true, scannerServerBusyMessage : message }));

    setScannerServerIdle = () => this.setState(Object.assign({}, this.state, { scannerServerBusy: false }));

    componentDidMount() {
        sagaMiddleware.run(watchPollStatus, this.props.dispatch, this.props.match.params.id);
    }

    allowWorkflowAccess = () => this.setState(Object.assign({}, this.state, { allow_workflow_access: true }));

    revokeWorkflowAccess = () => this.setState(Object.assign({}, this.state, { allow_workflow_access: false }));

    getIconType = (usbConnectionCode) => {
        if (usbConnectionCode == this.usbConnectionCodeDict.INITIALISED) {
            return "check";
        } else if (usbConnectionCode == this.usbConnectionCodeDict.DISCONNECTED) {
            return "api"
        } else if (usbConnectionCode == this.usbConnectionCodeDict.CONNECTED) {
            return "link"
        } else if (usbConnectionCode == this.usbConnectionCodeDict.ERRORED) {
            return "exclamation-circle"
        }
    }

    getColorType = (usbConnectionCode) => {
        if (usbConnectionCode == this.usbConnectionCodeDict.INITIALISED) {
            return "#27ae60";
        } else if (usbConnectionCode == this.usbConnectionCodeDict.DISCONNECTED) {
            return "#c0392b"
        } else if (usbConnectionCode == this.usbConnectionCodeDict.CONNECTED) {
            return "#27ae60"
        } else if (usbConnectionCode == this.usbConnectionCodeDict.ERRORED) {
            return "#c0392b"
        }
    }

    getHelpText = (device, usbConnectionCode) => {
        let line1, line2;

        if (usbConnectionCode == this.usbConnectionCodeDict.INITIALISED) {
            line1 = device + " is connected and initialised";
            line2 = "";
        } else if (usbConnectionCode == this.usbConnectionCodeDict.DISCONNECTED) {
            line1 = device + " is disconnected";
            line2 = "Please reconnect the cable tagged " + device;
        } else if (usbConnectionCode == this.usbConnectionCodeDict.CONNECTED) {
            line1 = device + " is connected and ready for startup";
            line2 = "";
        } else if (usbConnectionCode == this.usbConnectionCodeDict.ERRORED) {
            line1 = "Please remove and reconnect the cable tagged " + device;
            line2 = "Click the START SCANNER button once done";
        }

        return [
            <span key={0}>{line1}</span>, 
            <br key={1}></br>,
            <span key={2} className="hardware-section-retry">{line2}</span>
        ]
    }

    getIconForDevice = (device) => {
        if (device == this.hardwareDict.CAMERA) {
            return "video-camera";
        } else if (device == this.hardwareDict.SERIAL) {
            return "cluster";
        }  else if (device == this.hardwareDict.PREVIEW_CAMERA) {
            return "pic-center";
        } 
    }

    getHardwareRowPanel = (device, status) => {
        return <Row className="hardware-status-row">
            <Col span={3} className="hardware-status-icon-div">
                <Icon type={this.getIconForDevice(device)} className="hardware-status-icon"/>
            </Col>
            <Col span={17} className="hardware-section-header">
                <b>{device}</b>
                <Divider />
                {this.getHelpText(device, status)}
            </Col>
            <Col span={4} className="hardware-status-icon-div">
                <Icon 
                    className="hardware-status-icon" 
                    type={this.getIconType(status)} 
                    style={{color:this.getColorType(status)}} >
                </Icon>
            </Col>
        </Row>
    }

    render() {

        let allUsbDevicesConnected = true;
        let scannerStatus = (((this.props.device || {}).scanner_health || {}).scanner_response || {});
        let usbDependenciesStatus = (scannerStatus || {}).usbDependenciesStatus;
        let isMorpheusReachable = ((this.props.device || {}).scanner_health || {}).device_name != undefined;
        let isServerReachable = ((this.props.device || {}).scanner_health || {}).server_up;
        isServerReachable = isServerReachable == undefined ? false : isServerReachable;
        let hardwareError = false;

        let recommendServerRestart = (scannerStatus || {}).recommendServerRestart;
        recommendServerRestart = recommendServerRestart == undefined ? false : recommendServerRestart;

        if (usbDependenciesStatus != undefined) {
            for (let key in usbDependenciesStatus) {
                if (usbDependenciesStatus[key] != this.usbConnectionCodeDict.INITIALISED) {
                    hardwareError = true;
                }
                if (usbDependenciesStatus[key] != this.usbConnectionCodeDict.INITIALISED && 
                    usbDependenciesStatus[key] != this.usbConnectionCodeDict.CONNECTED) {
                    allUsbDevicesConnected = false;
                }
            }
        }
    
        let readyToStart = ((this.props.device || {}).scanner_health || {}).ready_to_start;
        readyToStart = readyToStart === undefined ? false : readyToStart;

        let isScanning = scannerStatus.scanning;
        isScanning = isScanning === undefined ? false : isScanning;
        let isBusy = scannerStatus.busy;
        isBusy = isBusy === undefined ? false : isBusy;
        let uiBusy = isBusy || (this.props.device || {}).uiBusy;
        uiBusy = uiBusy === undefined ? false : uiBusy;
        let progressState = this.props.match.params.progress_stage === undefined ? ProgressStateConstant.MAINPAGE : this.props.match.params.progress_stage;

        let scanner_control = null;
        let busyMessage = null;

        if (this.state.scannerServerBusy || ((this.props.device || {}).scanner_health || {}).server_starting) {
            uiBusy = true;
            busyMessage = this.state.scannerServerBusyMessage;
        }

        if (isBusy) {
            let busyOrder = scannerStatus.busyOrder;
            let busyDict = scannerStatus.busyDict;
            busyMessage = busyOrder.length > 0 ? busyDict[busyOrder[busyOrder.length - 1]] : "";
        } else if (uiBusy) {
            isBusy = true;
        }

        if (isServerReachable && recommendServerRestart) {
            scanner_control = <Row className="rounded-container">
                <Col className="hardware-status-panel" span={12} offset={6}>
                    <Row className="troubleshoot-fail-message">
                        <span style={{color:"#c0392b"}}><Icon type="exclamation-circle"></Icon></span>  &nbsp;
                        Hardware is not able to restart after multiple resets.
                    </Row>
                    <Row className="troubleshoot-steps">
                        <ol>
                            <li>Remove the cable tagged <b>CAMERA</b></li>
                            <li>Put the cable tagged <b>CAMERA</b> in the same USB port it was removed from</li>
                            <li>Remove the two cables tagged <b>SERIAL</b> and <b>PREVIEW CAMERA</b></li>
                            <li>Put the cables tagged <b>SERIAL</b> and <b>PREVIEW CAMERA</b> in the same USB ports they were removed from</li>
                            <li>Check the main <b>POWER</b> cable and switch. The switch should be in the <b>ON</b> position and lit <b>RED</b></li>
                            <li>Click the <b>DISCONNECT SCANNER</b> button above and then click <b>START SCANNER</b> on the next screen</li>
                        </ol>
                    </Row>
                </Col>
            </Row>
        } else if ((!allUsbDevicesConnected || hardwareError) && this.props.device && usbDependenciesStatus) {
            if (this.state.scannerServerBusy) {
                this.setScannerServerIdle();
            }
            scanner_control = <Row className="rounded-container">
                <Col className="hardware-status-panel" span={12} offset={6}>
                    {this.getHardwareRowPanel(this.hardwareDict.CAMERA, usbDependenciesStatus["cameraStatus"])}
                    {this.getHardwareRowPanel(this.hardwareDict.SERIAL, usbDependenciesStatus["arduinoStatus"])}
                    {this.getHardwareRowPanel(this.hardwareDict.PREVIEW_CAMERA, usbDependenciesStatus["previewStatus"])}
                    {scannerStatus.powerStatus == this.powerStatusDict.DISCONNECTED ?
                    <Row className="power-fail-message">
                        <span style={{color:"#c0392b"}}><Icon type="exclamation-circle"></Icon></span>  &nbsp;
                        Scanner may not be powered on. Please check the power switch/cable at the back.
                    </Row> : undefined }
                    <Row className="scanner-start-button-div">
                        <Button className="scanner-start-button" type="danger" size="large" disabled={!allUsbDevicesConnected} onClick={this.startScanner}>
                            Initialize Scanner
                        </Button>
                    </Row>
                </Col>
            </Row>
        } else if (isMorpheusReachable && !isServerReachable) {
            scanner_control = <Row className="rounded-container">
                <Col className="hardware-status-panel" span={12} offset={6} style={{borderWidth:0}}>
                    <Row className="scanner-start-button-div">
                        <Button className="scanner-start-button" type="danger" size="large" onClick={this.startScannerServer}>
                            Start Scanner
                        </Button>
                    </Row>
                </Col>
            </Row>
        } else if (isMorpheusReachable) {
            if (isScanning) {
                scanner_control = <ScanProgress id={this.props.match.params.id} />
            } else if (progressState === ProgressStateConstant.WORKFLOW) {
                if (this.state.allow_workflow_access) {
                    scanner_control = <ScanWorkflow id={this.props.match.params.id} revokeWorkflowAccess={this.revokeWorkflowAccess} />
                } else {
                    scanner_control = <Redirect to={'/' + globalUrlPrefix + '/scanners/' + this.props.match.params.id + '/'}></Redirect>
                }
            } else if (allUsbDevicesConnected) {
                scanner_control = <UserControls id={this.props.match.params.id} allowWorkflowAccess={this.allowWorkflowAccess} />
            }
        } else {
            scanner_control = <Row className="rounded-container">
                <Col className="hardware-status-panel" span={12} offset={6} style={{borderWidth:0}}>
                    <Row className="scanner-start-button-div">
                        Scanner Server is Down. Please contact Administrator.
                    </Row>
                </Col>
            </Row>
        }

        return (
            <div>
                <Row className="rounded-container">
                    <Col className="scanner-name arial-font" span={24}>
                        <Link to={"/" + globalUrlPrefix + "/scanners/" + this.props.match.params.id + "/"} className="device-name">
                            {((this.props.device || {}).scanner_health || {}).device_name}
                        </Link>
                    </Col>
                </Row>
                { (isBusy || isServerReachable) ? 
                <Row className="scanner-start-button-div">
                    <Button className="scanner-start-button" type="danger" size="large" onClick={this.stopScannerServer}>
                        Disconnect Scanner
                    </Button>
                </Row> : undefined }
                <Spin spinning={(isBusy && !isScanning) || uiBusy || this.state.starting_scanner} tip={busyMessage} size="large">
                    {scanner_control}
                </Spin>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        device: state.deviceStatusReducer[ownProps.match.params.id]
    };
};

export default connect(mapStateToProps)(ScannerView);